/* eslint-disable */
export default {
  title: 'Regio',
  NAOnlyMessage: 'Stel uw netnummer in. Dit wordt gebruikt voor lokaal bellen.',
  MultiWithNAMessage:
    'Stel het land en netnummer in voor uw regio. Dit wordt gebruikt voor lokale oproepen en het formatteren van telefoonnummers.',
  MultiWithoutNAMessage:
    'Selecteer het land waar u zich bevindt. Dit wordt gebruikt voor lokale oproepen en het formatteren van telefoonnummers.',
  country: 'Land',
  areaCode: 'Netnummer',
  areaCodePlaceholder: 'Netnummer invoeren',
} as const;

// @key: @#@"title"@#@ @source: @#@"Region"@#@
// @key: @#@"NAOnlyMessage"@#@ @source: @#@"Please set your area code. This will be used for local dialing."@#@
// @key: @#@"MultiWithNAMessage"@#@ @source: @#@"Please set the country and area code for your region. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"MultiWithoutNAMessage"@#@ @source: @#@"Please select the country you locate in. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"country"@#@ @source: @#@"Country"@#@
// @key: @#@"areaCode"@#@ @source: @#@"Area Code"@#@
// @key: @#@"areaCodePlaceholder"@#@ @source: @#@"Enter Area Code"@#@
